/**
* AbstractScenarioPlayer.js
* 
* Created on 2-okt-2013, 16:43:12
*
* @author Ivo Swartjes for Ranj
**/
import { AbstractOzContentPlayer } from "../contentplaying/ContentPlayingAPI";

export default class AbstractScenarioPlayer extends AbstractOzContentPlayer {
	constructor() {
        super();
    };
        
    init(scenario, storyMemento) {}
    
    getScenario() {}
    
    play() {}
    stop() {}
}